export const APPIDS = [
  {
    origin: "Network18",
    value: "d291281e-941b-4fe6-89ff-628024c2e475",
  },
];

export const FORM_API_URL = "https://adbot.nw18.com/api/addUser/";

export const BE_API_URL = "https://adbot.nw18.com/api/" ;

export const BE_CHEAPER = "https://adbot.nw18.com/api/products/";

export const BE_EXPENSIVE = "https://adbot.nw18.com/api/products/";

export const BE_INCOME_TAX_URL = "https://adbot.nw18.com/api/calculate-tax";

export const PREVIEW_APP_ID = "22121998"

